<template>
  <div class="news">
    <Header />
    <div class="banner">
      <div class="banner_title">{{ $t("header.news") }}</div>
    </div>
    <div class="news-box">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="news-section">
              <div class="news-title">{{ $t("header.news") }}</div>
              <div class="news-list">
                <div class="company-news">
                  <h5 :class="[isActive1 || isActive2 ? 'active' : '']">
                    {{ $t("news.news1") }}
                  </h5>
                  <a
                    href="javascript:;"
                    :class="[isActive1 ? 'active' : '']"
                    @click="showNew2"
                    >{{ $t("news.news2") }}</a
                  >
                  <a
                    href="javascript:;"
                    :class="[isActive2 ? 'active' : '']"
                    @click="showNew3"
                    >{{ $t("news.news3") }}</a
                  >
                </div>
                <div class="business-news">
                  <h5 :class="[isActive3 ? 'active' : '']">
                    {{ $t("news.news4") }}
                  </h5>
                  <a
                    href="javascript:;"
                    :class="[isActive3 ? 'active' : '']"
                    @click="showNew4"
                    >{{ $t("news.news5") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-8" v-show="isActive1">
            <div class="news-detail">
              <h3>{{ $t("news.news6") }}</h3>
              <span class="news-time">{{ $t("news.news7") }}：2017-11-28</span>
              <p>
                {{ $t("news.news8") }}
              </p>
              <p>
                {{ $t("news.news9") }}
              </p>
              <p>
                {{ $t("news.news10") }}
              </p>
            </div>
          </div>
          <div class="col-12 col-md-8" v-show="isActive2">
            <div class="news-detail">
              <h3>{{ $t("news.news11") }}</h3>
              <span class="news-time">{{ $t("news.news7") }}：2017-11-28</span>
              <p>
                {{ $t("news.news12") }}
              </p>
              <p>
                {{ $t("news.news13") }}
              </p>
            </div>
          </div>
          <div class="col-12 col-md-8" v-show="isActive3">
            <div class="news-detail">
              <h3>{{ $t("news.news14") }}</h3>
              <span class="news-time">{{ $t("news.news7") }}：2017-11-28</span>
              <p>
                {{ $t("news.news15") }}
              </p>
              <p>
                {{ $t("news.news16") }}
              </p>
              <p>
                {{ $t("news.news17") }}
              </p>
              <p>
                {{ $t("news.news18") }}
              </p>
              <p>
                {{ $t("news.news19") }}
              </p>
              <p>
                {{ $t("news.news20") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      isActive1: true,
      isActive2: false,
      isActive3: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    showNew2() {
      this.isActive1 = true;
      this.isActive2 = false;
      this.isActive3 = false;
    },
    showNew3() {
      this.isActive2 = true;
      this.isActive1 = false;
      this.isActive3 = false;
    },
    showNew4() {
      this.isActive1 = false;
      this.isActive2 = false;
      this.isActive3 = true;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.news {
  background: #f5f5f5;
}
.banner {
  background: url("../assets/image/news-banner.png") no-repeat;
  background-position: center;
  background-size: cover;
  height: 500px;
  position: relative;
  top: 140px;
  margin-bottom: 140px;
  width: 100%;
}
.banner_title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 60px;
  font-family: PingFang SC;
  font-style: italic;
  color: #ffffff;
  text-align: center;
}
.news-box {
  padding: 100px 0;
}
.news-section {
  padding: 0 20px;
  margin-bottom: 25px;
  .news-title {
    background: url("../assets/image/news-1.png") no-repeat;
    background-position: center;
    background-size: cover;
    height: 100px;
    font-size: 26px;
    font-weight: 800;
    color: #fefefe;
    text-align: center;
    line-height: 100px;
  }
  .news-list {
    background-color: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(5, 78, 164, 0.2);
    margin-top: 10px;
    padding: 35px 20px;
    .company-news {
      margin-bottom: 20px;
      border-bottom: 1px solid #e3e3e3;
    }
    h5 {
      font-size: 18px;
      color: #333333;
    }
    a {
      display: block;
      text-indent: 1em;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin: 20px 0;
    }
  }
}
.news-detail {
  h3 {
    font-size: 18px;
    font-weight: bold;
    color: #666666;
    text-align: center;
  }
  span {
    display: block;
    margin: 14px 0;
    font-size: 14px;
    color: #666666;
    margin: 50px 0 27px 0;
  }
  p {
    font-size: 14px;
    color: #333333;
    line-height: 25px;
    text-indent: 2em;
    margin-bottom: 25px;
  }
}
.active {
  color: #054ea4 !important;
}
@media (max-width: 1024px) and (min-width: 768px) {
  .banner {
    top: 30px;
    margin-bottom: 30px;
    height: 350px;
    background-size: contain;
  }
  .news-section .news-title {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
  }
  .news-detail {
    h3 {
      font-size: 16px;
    }
    span {
      font-size: 14px;
      margin: 25px 0 12px 0;
    }
  }
}
@media (max-width: 767px) and (min-width: 320px) {
  .banner {
    background-image: url("../assets/image/new-mobile-banner.png");
    background-size: 100%;
    background-position: center;
    top: 50px;
    margin-bottom: 50px;
    height: 230px;
  }
  .news-section .news-title {
    background-size: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
  }
  .banner_title {
    font-size: 25px;
  }
  .news-box {
    padding: 50px 0;
  }
  .news-list {
    padding: 13px 15px !important;
    margin-top: 5px !important;
    .company-news,
    .business-news {
      margin-bottom: 8px !important;
      h5 {
        font-size: 12px !important;
      }
      a {
        font-size: 12px !important;
        margin: 10px 0;
      }
    }
  }
  .news-section {
    padding: 0 5px;
  }
  .news-detail h3 {
    font-size: 14px;
    width: 200px;
    margin: 0 auto;
  }
  .news-detail span {
    font-size: 10px;
    margin: 25px 0 14px 0;
  }
  .news-detail p {
    font-size: 12px;
  }
}
</style>